import { useState, useEffect } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import apiClient from "../../utils/apiClient";
import Navbar from "../../components/navbar";

// Imaginary step components (you will create them later)
import SchoolingStep910 from "../../components/Counselling/EducationFlow/SchoolingStep910";
import SchoolingStep1112 from "../../components/Counselling/EducationFlow/SchoolingStep1112";
import UndergraduateStep from "../../components/Counselling/EducationFlow/UndergraduateStep";
import PostgraduateStep from "../../components/Counselling/EducationFlow/PostgraduateStep";
import DoctorateStep from "../../components/Counselling/EducationFlow/DoctorateStep";
import AdditionalInformationStep from "../../components/Counselling/EducationFlow/AdditionalInformationStep";
import { useNavigate } from "react-router-dom";

const EDUCATION_LEVELS = {
  SECONDARY: "Class 10th",
  ELEVENTH: "Class 11th",
  TWELFTH: "Class 12th",
  UNDERGRADS: "Undergrads",
  UNDERPOSTGRAD: "Underpostgrad",
  DOCTORATE: "Underdoctarate",
};

const EducationFormParent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [educationLevel, setEducationLevel] = useState("Random");
  const [steps, setSteps] = useState([]);

  // All form states (imaginary)
  const [step910, setStep910] = useState({});
  const [step1112, setStep1112] = useState({});
  const [stepAdditional, setStepAdditional] = useState({});
  const [undergrad, setUndergrad] = useState({});
  const [postgrad, setPostgrad] = useState({});
  const [doctorate, setDoctorate] = useState({});

  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    const checkBuyStatus = async () => {
      try {
        const response = await apiClient.get("/counselling/buyStatus");
        console.log(response);
        if (response?.data?.success) {
          if (response.data.boughtStatus == false) {
            navigate("/counselling-checkout");
          }
        }
      } catch (error) {
        console.error("Failed to check counselling buy status:", error);
      } finally {
        setCheckingStatus(false);
      }
    };

    checkBuyStatus();
  }, []);

  // -------------------------------
  // FETCH USER EDUCATION LEVEL
  // -------------------------------
  useEffect(() => {
    const fetchEducationLevel = async () => {
      try {
        const response = await apiClient.get("/counselling/category");

        if (response.data?.success) {
          // console.log(response.data.data.category);
          buildSteps(response.data.data.category || "");
          setEducationLevel(response.data.data.category);
        }
      } catch (error) {
        console.error(
          "❌ Error fetching education level:",
          error?.response?.data || error.message,
        );
      }
    };

    fetchEducationLevel();
  }, []);

  // useEffect(() => {
  //   //temporary

  // }, []);

  // const fetchEducationLevel = async () => {
  //   try {
  //     const res = await apiClient.get("/users/current-education-level");
  //     const level = res.data?.educationLevel;
  //     setEducationLevel(level || "");

  //     buildSteps(level || "");
  //   } catch (err) {
  //     console.error("Error fetching education level:", err);
  //   }
  // };

  // ----------------------------------
  // DYNAMIC STEP BUILDER
  // ----------------------------------
  const buildSteps = (level) => {
    const s = [{ label: "Schooling (9th & 10th)", component: "step910" }];
    if (level == "" || level === EDUCATION_LEVELS.SECONDARY) {
      s.push({ label: "Additional Information", component: "additionalInfo" });
    } else if (
      level === EDUCATION_LEVELS.ELEVENTH ||
      level === EDUCATION_LEVELS.TWELFTH
    ) {
      s.push({ label: "Schooling (11th & 12th)", component: "step1112" });
      s.push({ label: "Additional Information", component: "additionalInfo" });
    } else if (level === EDUCATION_LEVELS.UNDERGRADS) {
      s.push({ label: "Schooling (11th & 12th)", component: "step1112" });
      s.push({ label: "Undergraduate", component: "undergrad" });
      s.push({ label: "Additional Information", component: "additionalInfo" });
    } else if (level === EDUCATION_LEVELS.UNDERPOSTGRAD) {
      s.push({ label: "Schooling (11th & 12th)", component: "step1112" });
      s.push({ label: "Undergraduate", component: "undergrad" });
      s.push({ label: "Postgraduate", component: "postgrad" });
      s.push({ label: "Additional Information", component: "additionalInfo" });
    } else if (level === EDUCATION_LEVELS.DOCTORATE) {
      s.push({ label: "Schooling (11th & 12th)", component: "step1112" });
      s.push({ label: "Undergraduate", component: "undergrad" });
      s.push({ label: "Postgraduate", component: "postgrad" });
      s.push({ label: "Doctorate", component: "doctorate" });
      s.push({ label: "Additional Information", component: "additionalInfo" });
    } else {
      s.push({ label: "Schooling (11th & 12th)", component: "step1112" });
      s.push({ label: "Undergraduate", component: "undergrad" });
      s.push({ label: "Postgraduate", component: "postgrad" });
      s.push({ label: "Additional Information", component: "additionalInfo" });
    }
    setSteps(s);
  };

  // ----------------------------------
  // STEP CHANGE HANDLERS
  // ----------------------------------
  const handleNext = () => {
    if (activeStep < steps.length - 1) setActiveStep(activeStep + 1);
    else {
      if (educationLevel === EDUCATION_LEVELS.SECONDARY) {
        navigate("/stream-info");
      } else if (
        educationLevel === EDUCATION_LEVELS.ELEVENTH ||
        educationLevel === EDUCATION_LEVELS.TWELFTH
      ) {
        navigate("/domain-info");
      } else {
        navigate("/domain-info-for-rest");
      }
    }
  };

  const handleBack = () => {
    if (activeStep > 0) setActiveStep(activeStep - 1);
  };

  // ----------------------------------
  // CUSTOM STEP ICON
  // ----------------------------------
  const CustomStepIcon = ({ active, completed }) => {
    const size = isMobile ? 10 : 16;
    return (
      <div
        style={{
          width: size,
          height: size,
          background: completed ? "#30B0C7" : "#ccc",
          borderRadius: "50%",
        }}
      ></div>
    );
  };

  // ----------------------------------
  // RENDER CURRENT STEP COMPONENT
  // ----------------------------------
  const renderStepContent = () => {
    const current = steps[activeStep]?.component;

    switch (current) {
      case "step910":
        return (
          <SchoolingStep910
            data={step910}
            setData={setStep910}
            handleNext={handleNext}
          />
        );

      case "step1112":
        return (
          <SchoolingStep1112
            data={step1112}
            setData={setStep1112}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );

      case "additionalInfo":
        return (
          <AdditionalInformationStep
            data={stepAdditional}
            setData={setStepAdditional}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );

      case "undergrad":
        return (
          <UndergraduateStep
            data={undergrad}
            setData={setUndergrad}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );

      case "postgrad":
        return (
          <PostgraduateStep
            data={postgrad}
            setData={setPostgrad}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );

      case "doctorate":
        return (
          <DoctorateStep
            data={doctorate}
            setData={setDoctorate}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );

      default:
        return null;
    }
  };

  if (!educationLevel) return <p>Loading...</p>;

  return (
    <div>
      <Navbar />

      {/* Stepper */}
      <div style={{ width: "100%", marginTop: "4vh" }}>
        <Stepper
          sx={{ flexWrap: "wrap" }}
          activeStep={activeStep}
          alternativeLabel
        >
          {steps.map((step, index) => (
            <Step key={index}>
              <StepLabel
                StepIconComponent={() => (
                  <CustomStepIcon completed={activeStep >= index} />
                )}
              >
                <p style={{ fontSize: "10px" }}>{step.label}</p>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>

      {/* Step content */}
      <div style={{ marginTop: "20px" }}>{renderStepContent()}</div>
    </div>
  );
};

export default EducationFormParent;
